import { Component, OnInit } from '@angular/core';
import { DataService } from "../services/dataservice.service";

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit {

  private intro: string = '';
  private body: string = '';

  constructor(private dataService: DataService) {

    this.dataService.dataServiceArrived.subscribe(
      (data) =>
      {
        this.intro = data.filter((data) => {return data.Type == 'intro-news'})[0].Content;
        this.body = data.filter((data) => {return data.Type == 'body-news'})[0].Content;
      }
    )
  }

  ngOnInit() {
    this.dataService.getContent()
  }

}



// WEBPACK FOOTER //
// ./src/app/main/news/news.component.ts